import React, { useState } from 'react';
import '../assets/css/custom-rating-radio.css';

const CustomRatingRadio = (props)=> {

  

  const handleChange=(e)=>{
    
    props.setRating(e.target.id);
  }

	return(
  <>
    <div className="custom-rating-radio">
      <input  type="radio" id={props.id} name={props.name} onClick={handleChange}/>
      <label className={props.isActive==true ? "active":""} htmlFor={props.id}>{props.text}</label>
      
    </div>
  </>
	);
}

export default CustomRatingRadio